import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from 'react';
import { StyledDropdownContainer } from "./styles";
import { Dropdown, MenuRow } from '@applyboard/ui-components';
export var ChartFilterDropdown = function ChartFilterDropdown(_ref) {
  var children = _ref.children,
    onOptionSelect = _ref.onOptionSelect,
    options = _ref.options,
    placeholder = _ref.placeholder,
    selectedOption = _ref.selectedOption,
    testId = _ref.testId,
    track = _ref.track;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    dropdownOpen = _useState2[0],
    setDropdownOpen = _useState2[1];
  var onOptionSelected = function onOptionSelected(option) {
    if (option) {
      onOptionSelect(option);
    }
    setDropdownOpen(false);
  };
  useEffect(function () {
    if (options[0]) {
      onOptionSelect(options[0]);
    }
  }, [options]);
  return /*#__PURE__*/React.createElement(StyledDropdownContainer, {
    "data-testid": testId
  }, /*#__PURE__*/React.createElement(Dropdown, {
    InputProps: {
      placeholder: placeholder,
      value: selectedOption.label
    },
    MenuProps: {
      setOpen: setDropdownOpen,
      open: dropdownOpen
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, options.map(function (option) {
    return /*#__PURE__*/React.createElement("div", {
      "data-testid": "".concat(testId, "-option"),
      key: option.label
    }, /*#__PURE__*/React.createElement(MenuRow, {
      id: option.label,
      value: option.label,
      selected: selectedOption.label === option.label,
      onClick: function onClick() {
        onOptionSelected(option);
        if (track) {
          track();
        }
      }
    }));
  }), children && /*#__PURE__*/React.createElement(MenuRow, null, children))));
};